import supabase from '../supabaseClient'
import { TABLE_NAMES } from '../config'
import { resolveDemoOrgId } from './adminDemoSession'

/** Community portal is never gated — setup mode is disabled for communities. */
export function isCommunitySetupMode(_value) {
  return false
}

export function communityHomeRoute(_setupMode) {
  return '/community/dashboard'
}

/** @deprecated Setup mode removed — always false. */
export function isCommunityOverviewPath(_pathname) {
  return false
}

/** @deprecated Setup mode removed — always false. */
export function isCommunityManagementBlockedPath(_pathname) {
  return false
}

export const SETUP_BLOCKED_MANAGEMENT_TABS = new Set()

/**
 * Load setup_mode for the signed-in community manager.
 * Returns { setupMode, communityId }. setupMode is always false.
 */
export async function fetchManagerCommunitySetupMode(userId) {
  if (!userId) return { setupMode: false, communityId: null }

  const { data: profile, error: profileError } = await supabase
    .from(TABLE_NAMES.USERS)
    .select('community_id, community_manager')
    .eq('user_id', userId)
    .maybeSingle()

  const communityId = resolveDemoOrgId('community', userId, profileError ? null : profile?.community_id)
  return { setupMode: false, communityId }
}
